// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__7W2Wf","label":"Labeled_label__wsYnh","divider":"Labeled_divider__2GAZB"};